// ADR-0072 决策 1 镜像支撑件：复刻 Lombok @Value 生成 hashCode 的散列语义，
// 供本包各镜像值对象（GradientStop / ShadowParams / PathCommand 子类）共用，避免逐类重复。
package top.wcpe.allincore.ui.runtime.render.model

/** Lombok 生成 hashCode 使用的乘数。 */
private const val LOMBOK_PRIME = 59

/** Lombok 对 boolean true 的散列贡献值。 */
private const val LOMBOK_TRUE = 79

/** Lombok 对 boolean false 的散列贡献值。 */
private const val LOMBOK_FALSE = 97

/** 逐位复刻 Lombok @Value hashCode：种子 1、59 倍累乘；元素须先按 floatToIntBits / boolean 折算为 int。 */
internal fun lombokHash(vararg elements: Int): Int {
    var result = 1
    for (element in elements) {
        result = result * LOMBOK_PRIME + element
    }
    return result
}

/** 复刻 Lombok 对 boolean 的散列贡献（true → 79，false → 97）。 */
internal fun lombokBooleanHash(value: Boolean): Int = if (value) LOMBOK_TRUE else LOMBOK_FALSE
